export const businessSuggestions = [
  "How many total(repeat + fresh) disbursed leads for mobavenue in 2025",
  "How many fresh disbursed leads for mobavenue partner in 2025",
  "How many total fresh applied leads for mobavenue in 2025",
  "How many total users for mobavenue in 2025",
  "What is the conversion ratio for partner mobavenue in 2025",
  "Get the Good Leads Ratio for mobavenue for 2025",
  "Get the Cold Leads Ratio for mobavenue for 2025",
  "How many loans were rejected with reason in 2025 for mobavenue partner?",
  "Total FRESH Disbursed Amount for mobavenue in 2025",
  "List names of aggregators",
  "List partner names of aggregator Adsflourish.",
  "What are the Loan statuses with their respective lead count of mobavenue partner for 2025",
];

export const collectionSuggestions = [
  "How much loan was disbursed in the last week",
  "Out of the disbursed loans, how many are overdue",
  "What is the total EMI amount scheduled vs paid over time",
  "How many EMIs were on-time, foreclosed, or overdue",
  "What is the collection efficiency by month",
  "What is total overdue amount and its trend month wise",
  "Provisioning against GNPA to calculate NNPA",
  "emi bounce percent per month for 2025",
  "emi's that were bounced but later paid for 2025",
  "What is the total loan book summary",
  "How much payment was received vs due last week",
  "What are the partial payments and their distribution",
  "What is the collected amount per payment provider",
  "Daily trend chart for disbursement and repayment",
  "Compare digital versus cash collections for last month",
];
